import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ShieldCheckIcon, TrendingUpIcon, ArrowRightIcon, CreditCardIcon, InfoIcon } from 'lucide-react';
export function DepositPayment() {
  const depositAmount = 250;
  const vatRate = 0.21;
  const vatAmount = depositAmount * vatRate;
  const totalAmount = depositAmount + vatAmount;
  const bonusAmount = 500;
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white py-12" data-id="element-8374">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8375">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-8376">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-2xl mb-6 shadow-lg" data-id="element-8377">
            <ShieldCheckIcon className="w-10 h-10 text-white" data-id="element-8378" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#132C53] mb-4" data-id="element-8379">
            Depozit de Colaborare CLC
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-8380">
            Ultimul pas pentru a activa colaborarea și a începe să generezi
            venituri
          </p>
        </motion.div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-8381">
          {/* Deposit Details */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl shadow-lg p-8" data-id="element-8382">
            <h2 className="text-2xl font-bold text-[#132C53] mb-6" data-id="element-8383">
              Detalii depozit
            </h2>

            <div className="space-y-6" data-id="element-8384">
              {/* Deposit Breakdown */}
              <div className="bg-gray-50 rounded-xl p-6" data-id="element-8385">
                <div className="flex items-center justify-between mb-4" data-id="element-8386">
                  <span className="text-gray-600" data-id="element-8387">Depozit de bază</span>
                  <span className="text-2xl font-bold text-[#132C53]" data-id="element-8388">
                    {depositAmount} €
                  </span>
                </div>
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200" data-id="element-8389">
                  <span className="text-gray-600" data-id="element-8390">TVA (21%)</span>
                  <span className="text-xl font-semibold text-gray-700" data-id="element-8391">
                    {vatAmount.toFixed(2)} €
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-8392">
                  <span className="text-lg font-semibold text-gray-700" data-id="element-8393">
                    Total de plată
                  </span>
                  <span className="text-3xl font-bold text-[#357BEB]" data-id="element-8394">
                    {totalAmount.toFixed(2)} €
                  </span>
                </div>
              </div>

              {/* Payment Info */}
              <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4" data-id="element-8395">
                <div className="flex items-start space-x-3" data-id="element-8396">
                  <InfoIcon className="w-5 h-5 text-[#357BEB] flex-shrink-0 mt-0.5" data-id="element-8397" />
                  <div className="text-sm text-gray-700" data-id="element-8398">
                    <p className="font-semibold mb-1" data-id="element-8399">Plată unică</p>
                    <p data-id="element-8400">
                      Acest depozit se plătește o singură dată la începutul
                      colaborării și reprezintă garanția ta de angajament.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Benefits */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-gradient-to-br from-[#21A366] to-[#1a8555] rounded-2xl shadow-lg p-8 text-white" data-id="element-8401">
            <h2 className="text-2xl font-bold mb-6" data-id="element-8402">
              🎁 Beneficiul tău garantat
            </h2>

            <div className="space-y-6" data-id="element-8403">
              <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-xl p-6" data-id="element-8404">
                <div className="flex items-center space-x-3 mb-4" data-id="element-8405">
                  <TrendingUpIcon className="w-8 h-8" data-id="element-8406" />
                  <span className="text-2xl font-bold" data-id="element-8407">
                    Depozit dublat la prima vânzare!
                  </span>
                </div>
                <p className="text-lg leading-relaxed" data-id="element-8408">
                  La prima ta tranzacție de vânzare finalizată, primești înapoi
                  depozitul PLUS un bonus de{' '}
                  <span className="font-bold text-2xl" data-id="element-8409">{bonusAmount} €</span> în
                  plus față de comisionul tău normal.
                </p>
              </div>

              <div className="space-y-3" data-id="element-8410">
                <div className="flex items-start space-x-3" data-id="element-8411">
                  <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-8412" />
                  <div data-id="element-8413">
                    <p className="font-semibold mb-1" data-id="element-8414">Returnare garantată</p>
                    <p className="text-sm text-gray-100" data-id="element-8415">
                      Primești înapoi {depositAmount} € la prima vânzare
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3" data-id="element-8416">
                  <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-8417" />
                  <div data-id="element-8418">
                    <p className="font-semibold mb-1" data-id="element-8419">
                      Bonus de {bonusAmount} €
                    </p>
                    <p className="text-sm text-gray-100" data-id="element-8420">
                      Peste comisionul tău normal de agent
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3" data-id="element-8421">
                  <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-8422" />
                  <div data-id="element-8423">
                    <p className="font-semibold mb-1" data-id="element-8424">Fără alte costuri</p>
                    <p className="text-sm text-gray-100" data-id="element-8425">
                      Nu există taxe lunare sau alte plăți ascunse
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Why This Deposit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-white rounded-2xl shadow-lg p-8 mb-12" data-id="element-8426">
          <h2 className="text-2xl font-bold text-[#132C53] mb-6" data-id="element-8427">
            De ce acest depozit?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-8428">
            <div className="text-center" data-id="element-8429">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-8430">
                <ShieldCheckIcon className="w-8 h-8 text-[#357BEB]" data-id="element-8431" />
              </div>
              <h3 className="font-bold text-[#132C53] mb-2" data-id="element-8432">
                Angajament reciproc
              </h3>
              <p className="text-sm text-gray-600" data-id="element-8433">
                Demonstrezi seriozitatea ta, iar noi investim în training-ul și
                suportul tău complet
              </p>
            </div>

            <div className="text-center" data-id="element-8434">
              <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-8435">
                <TrendingUpIcon className="w-8 h-8 text-[#21A366]" data-id="element-8436" />
              </div>
              <h3 className="font-bold text-[#132C53] mb-2" data-id="element-8437">
                Motivație suplimentară
              </h3>
              <p className="text-sm text-gray-600" data-id="element-8438">
                Știind că vei primi {bonusAmount} € bonus la prima vânzare, vei
                fi și mai motivat să reușești rapid
              </p>
            </div>

            <div className="text-center" data-id="element-8439">
              <div className="w-16 h-16 bg-purple-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-8440">
                <CheckCircleIcon className="w-8 h-8 text-purple-600" data-id="element-8441" />
              </div>
              <h3 className="font-bold text-[#132C53] mb-2" data-id="element-8442">
                Protecție pentru ambele părți
              </h3>
              <p className="text-sm text-gray-600" data-id="element-8443">
                Asigură că ambele părți sunt serioase și angajate în relația de
                colaborare
              </p>
            </div>
          </div>
        </motion.div>

        {/* Example Calculation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-gradient-to-r from-[#357BEB] to-[#21A366] rounded-2xl shadow-lg p-8 text-white mb-12" data-id="element-8444">
          <h2 className="text-2xl font-bold mb-6" data-id="element-8445">📊 Exemplu concret</h2>

          <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-xl p-6" data-id="element-8446">
            <p className="text-lg mb-4" data-id="element-8447">
              Să presupunem că finalizezi o vânzare cu comision de 3.000 €:
            </p>

            <div className="space-y-3 text-lg" data-id="element-8448">
              <div className="flex items-center justify-between pb-3 border-b border-white border-opacity-30" data-id="element-8449">
                <span data-id="element-8450">Comision normal agent (conform Scara Performanței)</span>
                <span className="font-bold" data-id="element-8451">3.000 €</span>
              </div>
              <div className="flex items-center justify-between pb-3 border-b border-white border-opacity-30" data-id="element-8452">
                <span data-id="element-8453">Returnare depozit</span>
                <span className="font-bold text-yellow-300" data-id="element-8454">
                  + {depositAmount} €
                </span>
              </div>
              <div className="flex items-center justify-between pb-3 border-b border-white border-opacity-30" data-id="element-8455">
                <span data-id="element-8456">Bonus CLC pentru prima vânzare</span>
                <span className="font-bold text-yellow-300" data-id="element-8457">
                  + {bonusAmount} €
                </span>
              </div>
              <div className="flex items-center justify-between pt-3" data-id="element-8458">
                <span className="text-xl font-bold" data-id="element-8459">Total primit</span>
                <span className="text-3xl font-bold" data-id="element-8460">
                  {(3000 + depositAmount + bonusAmount).toLocaleString()} €
                </span>
              </div>
            </div>
          </div>

          <p className="mt-6 text-center text-lg" data-id="element-8461">
            💡 Depozitul tău se transformă într-un bonus de{' '}
            <span className="font-bold text-yellow-300" data-id="element-8462">
              {depositAmount + bonusAmount} €
            </span>{' '}
            la prima vânzare!
          </p>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-8463">
          <button className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-[#357BEB] to-[#21A366] text-white px-10 py-5 rounded-xl font-bold text-xl hover:shadow-2xl transition-all transform hover:scale-105" data-id="element-8464">
            <CreditCardIcon className="w-6 h-6" data-id="element-8465" />
            <span data-id="element-8466">Plătește depozitul ({totalAmount.toFixed(2)} €)</span>
          </button>

          <Link to="/support" className="inline-flex items-center justify-center space-x-2 bg-white text-[#132C53] px-10 py-5 rounded-xl font-bold text-xl border-2 border-gray-300 hover:shadow-xl transition-all" data-id="element-8467">
            <span data-id="element-8468">Am întrebări</span>
            <ArrowRightIcon className="w-6 h-6" data-id="element-8469" />
          </Link>
        </motion.div>

        {/* Footer Note */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="mt-12 text-center" data-id="element-8470">
          <p className="text-sm text-gray-500" data-id="element-8471">
            🔒 Plata este securizată și procesată printr-un gateway de plată
            certificat
          </p>
          <p className="text-sm text-gray-500 mt-2" data-id="element-8472">
            Ai nevoie de ajutor?{' '}
            <Link to="/support" className="text-[#357BEB] hover:underline" data-id="element-8473">
              Contactează suportul
            </Link>
          </p>
        </motion.div>
      </div>
    </div>;
}